import { Component, Prop, PropSync, Ref, VModel, Vue } from 'vue-property-decorator';
import { Category } from '@/models/Category';
import { sanitizeString } from '@/support/String';

@Component<CategoryAutocomplete>({})
export default class CategoryAutocomplete extends Vue {
  //#region @VModel

  @VModel()
  protected internalValue!: string | Category | Category[];

  //#endregion

  //#region @PropSyncs

  @PropSync('searchInput')
  protected internalSearchInput!: string;

  //#endregion

  //#region @Props

  @Prop({ default: 'keyboard_arrow_down' })
  protected appendIcon!: string;

  @Prop({ default: '#49B39D' })
  protected color!: string;

  @Prop({ default: false })
  protected disabled!: boolean;

  @Prop({ default: () => [] })
  protected items!: Category[];

  @Prop({ default: 'Choose a category' })
  protected label!: string;

  @Prop({ default: 'Category' })
  protected placeholder!: string;

  @Prop({ default: true })
  protected returnObject!: boolean;

  @Prop({ default: 'Category search' })
  protected searchPlaceholder!: string;

  @Prop({ default: 'Category' })
  protected selectionSummaryLabel!: string;

  @Prop({ default: true })
  protected showPills!: boolean;

  //#endregion

  @Ref()
  protected categoryAutocomplete!: HTMLDivElement;

  protected sanitizeString = sanitizeString;

  //#region Handlers

  protected onFocus(): void {
    this.$emit('focus');
  }

  //#endregion

  //#region Helpers

  protected get itemsWithDisabledWhereHasChild(): Category[] {
    return this.items ? this.items.map((item) => {
      if (item.sub_categories && item.sub_categories.length) {
        (item as any).disabled = true;

        return item;
      }

      return item;
     }) : [];
  }

  protected isItemWithChildren(item: Category): boolean {
    return !! item && !! item.sub_categories && !! item.sub_categories.length;
  }

  protected isItemChecked(item: Category): boolean {
    return Array.isArray(this.internalValue) && !! this.internalValue.find((val) => val.id === item.id)
  }

  protected isChild(item: Category): boolean {
    return !! item.parent_id;
  }

  protected findParent(parent_id: string): undefined | Category {
    return this.items ? this.items.find((item) => item.id === parent_id) : undefined;
  }

  protected itemText(item: Category): string {
    const parent = this.findParent(item && item.parent_id ? item.parent_id : '');

    if (! parent) {
      if (this.isItemWithChildren(item)) {
        return `<span style="color: #000;">${item.name}:</span>`;
      }

      return `${item ? item.name : ''}${this.isItemWithChildren(item) ? ':' : ''}`;
    }

    return `<span style="color: #000;">—</span> ${item.name}`;
  }

  //#endregion
}
